import React from 'react';
import './ContainerTextContent.scss';
import Typography from '../../Typography/Typography';
import { classNameBuilder } from '../../../utils/className';
import Button from '../../Button/Button';
import { IContainerTextProps } from './types';
import { VacancyNotFoundImage } from '../../../assets/icons/svgIconsForJSX';

const ContainerTextContent: React.FC<IContainerTextProps> = ({
    typeContainer = 'little',
    reverse,
    content,
    button,
    vacancyNotFound,
}) => {
    const cn = classNameBuilder('text-container');
    const mod = {
        typeContainer: typeContainer,
        contentPositionReverse: reverse,
        contentPosition: content.position,
    };

    return (
        <div className={cn(mod)}>
            {vacancyNotFound && <VacancyNotFoundImage />}
            <Typography variant="h2">{content.title}</Typography>
            {content.subTitle && (
                <Typography className={cn('subTitle')} color="blue">
                    {content.subTitle}
                </Typography>
            )}
            <Typography className={cn('text')}>{content.text}</Typography>
            {content.linkList?.length ? (
                <ul className={cn('link-list')}>
                    {content.linkList?.map((value) => (
                        <li key={`link-${value?.id}`}>
                            <Typography className={cn('link-text')}>
                                {value?.name}
                                {' - '}
                                {value?.link && (
                                    <a
                                        href={value?.link}
                                        target={'_blank'}
                                        rel="noopener noreferrer">
                                        Смотреть
                                    </a>
                                )}
                            </Typography>
                        </li>
                    ))}
                </ul>
            ) : (
                <></>
            )}
            {button?.url && (
                <a href={button.url}>
                    <Button onClick={button.onClickHandler}>{button.text}</Button>
                </a>
            )}
            {button?.onClickHandler && (
                <Button onClick={button?.onClickHandler}>{button?.text}</Button>
            )}
        </div>
    );
};

export default ContainerTextContent;
